import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { CustomerOpportunityForm } from '../customer/components/CustomerOpportunity/CustomerOpportunity'
import { authedAxios } from '../utils'
import useAlert from '../hooks/useAlert'

const OpportunityEditModal = ({
  onClose,
  onSubmit,
  editingOpportunity,
  pipelines,
  products,
  billingCycleTypes,
}) => {
  const getCopy = (original) => {
    return original ? JSON.parse(JSON.stringify(original)) : null
  }
  const [localCopy, setLocalCopy] = useState(null)

  useEffect(() => {
    setLocalCopy(getCopy(editingOpportunity))
  }, [editingOpportunity])

  const updateOpportunity = (key, val) => {
    setLocalCopy((prev) => ({ ...prev, [key]: val }))
  }

  const stages =
    pipelines.find((p) => p.id === '__OPPORTUNITIES__')?.stages || []

  const { createAlert, createGenericErrorAlert } = useAlert()

  const save = () => {
    return authedAxios
      .put(
        `/api/customer/${localCopy.customer.id}/opportunity/${localCopy.id}`,
        localCopy
      )
      .then(() => {
        onSubmit(localCopy)
        createAlert({ message: 'Opportunity saved successfully' })
      })
      .catch({ createGenericErrorAlert })
  }

  return (
    <Dialog open={!!editingOpportunity} fullWidth maxWidth={'lg'}>
      <DialogTitle>
        Edit opportunity with {editingOpportunity?.customer?.name}
      </DialogTitle>

      <DialogContent>
        {editingOpportunity && (
          <CustomerOpportunityForm
            isEditing={true}
            currentOpportunity={localCopy}
            updateOpportunity={updateOpportunity}
            billingCycleTypes={billingCycleTypes}
            stages={stages}
            products={products}
            updateProducts={(value) => updateOpportunity('products', value)}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant={'outlined'}>
          Cancel
        </Button>
        <Button onClick={save} variant={'contained'} color={'primary'}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default OpportunityEditModal
